// src/components/siteHeader.jsx
import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "./siteHeader.css";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const menuRef = useRef(null);

  // Close the menu when route changes
  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  // Optional: prevent body scroll when menu is open on mobile
  useEffect(() => {
    const { body } = document;
    if (open) {
      body.style.overflow = "hidden";
    } else {
      body.style.overflow = "";
    }
    return () => (body.style.overflow = "");
  }, [open]);

  // Close on Escape
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <div role="banner" className="site-header">
      <Link to="/" className="logo-link" aria-label="ChicLogic.io home">
        <img
          src={`${process.env.PUBLIC_URL}/Chiclogiclogo.png`}
          alt="ChicLogic.io logo"
          className="logo-image"
        />
      </Link>

      {/* Hamburger button (visible on small screens) */}
      <button
        className="menu-toggle"
        aria-label="Toggle navigation"
        aria-controls="primary-nav"
        aria-expanded={open ? "true" : "false"}
        onClick={() => setOpen((v) => !v)}
      >
        {/* simple SVG icon that animates to X when open */}
        <svg
          className={`hamburger ${open ? "is-open" : ""}`}
          width="28"
          height="28"
          viewBox="0 0 24 24"
          role="img"
          aria-hidden="true"
        >
          <path className="line line1" d="M3 6h18" />
          <path className="line line2" d="M3 12h18" />
          <path className="line line3" d="M3 18h18" />
        </svg>
      </button>

      {/* Nav */}
      <nav
        id="primary-nav"
        ref={menuRef}
        className={`site-nav ${open ? "open" : ""}`}
      >
        <Link to="/hashtag-research" className="site-sign-in-button">
          Get Free Hashtag Ideas
        </Link>
        <Link to="/login" className="site-sign-in-button">
          Sign In
        </Link>
        <Link to="/signup" className="site-cta-button">
          Start Free Trial
        </Link>
      </nav>
    </div>
  );
}
